import React from "react";
import { createBrowserRouter } from "react-router-dom";
import { ROUTE_PATH } from "../constants/route";
import PublicLayout from "../layout/PublicLayout";
import PaymentSuccessPage from "../pages/Checkout/PaymentSuccessPage";
import PaymentFailedPage from "../pages/Checkout/PaymentFailedPage";
import KeepItemsPaymentSuccess from "../pages/Closet/KeepItemsPaymentSuccess";
import OrderHistory from "../pages/OrderHistory";
import OrderHistoryDistails from "../pages/OrderHistory/OrderHistoryDistails";
import UserProfile from "../pages/UserProfile";
import EditProfile from "../pages/UserProfile/EditProfile";
import Settings from "../pages/Settings";
import CustomerSupport from "../pages/CustomerSupport";
import ForgetPassword from "../pages/ForgetPassword";
import CheckInbox from "../pages/ForgetPassword/CheckInbox";
import ResetPassword from "../pages/ResetPassword";
import LinkExpired from "../pages/ForgetPassword/LinkExpired";

const Closet = React.lazy(() => import('../pages/Closet'));
const Home = React.lazy(() => import('../pages/Home'));
const Login = React.lazy(() => import('../pages/Login'));
const SignUpForm = React.lazy(() => import('../pages/SignUp'));
const AboutUs = React.lazy(() => import('../pages/AboutUs'));
const HowItWorksPage = React.lazy(() => import('../pages/HowItWorksPage'));
const Error = React.lazy(() => import('../pages/404'));
const Info = React.lazy(() => import('../pages/Info'));
const BrowsePage = React.lazy(() => import('../pages/Browse/DesignerPage'));
const Profile = React.lazy(() => import('../pages/Profile'));
const DesignerProductsList = React.lazy(() => import('../pages/DesignerProductsList'));
const ProductList = React.lazy(() => import('../pages/ProductListPage'));
const ProductDetails = React.lazy(() => import('../pages/ProductDetails'));
const Bag = React.lazy(() => import('../pages/Bag'))
const Checkout = React.lazy(() => import('../pages/Checkout'))

const routes = createBrowserRouter([
  {
    path: ROUTE_PATH.LOGIN,
    element: (
      <PublicLayout >
        <Login />
      </PublicLayout>
    ),
  },
  {
    path: ROUTE_PATH.PRODUCT_DETAIL,
    element: (
      <PublicLayout>
        <ProductDetails />
      </PublicLayout>
    ),
  },
  {
    path: ROUTE_PATH.PROFILE,
    element:(
      <PublicLayout privateRoute={true}>
        <Profile/>
      </PublicLayout>
    )
  },
  {
    path: ROUTE_PATH.ABOUT,
    element: (
      <PublicLayout>
        <AboutUs />
      </PublicLayout>
    ),
  },
  {
    path: ROUTE_PATH.HOW_IT_WORKS,
    element: (
      <PublicLayout>
        <HowItWorksPage />
      </PublicLayout>
    ),
  },
  {
    path: ROUTE_PATH.SIGNUP,
    element: (
      <PublicLayout>
        <SignUpForm />
      </PublicLayout>
    ),
  },
  {
    path: ROUTE_PATH.HOME,
    element: (
        <PublicLayout>
          <Home />
        </PublicLayout>
    ),
  },
  {
    path: ROUTE_PATH.TERMS_AND_CONDITION,
    element: (
      <PublicLayout>
        <Info activeTab={0} />
      </PublicLayout>
    ),
  },
  {
    path: ROUTE_PATH.PRIVACY_POLICY,
    element: (
      <PublicLayout>
        <Info activeTab={1} />
      </PublicLayout>
    ),
  },
  {
    path: ROUTE_PATH.BROWSE,
    element: (
      <PublicLayout>
        <BrowsePage />
      </PublicLayout>
    ),
  },

  {
    path: ROUTE_PATH.BAG,
    element: (
      <PublicLayout>
        <Bag />
      </PublicLayout>
    ),
  },

  {
    path: ROUTE_PATH.CHECKOUT,
    element: (
      <PublicLayout privateRoute={true}>
        <Checkout />
      </PublicLayout>
    ),
  },
  
  {
    path: ROUTE_PATH.PRODUCT_LIST,
    element: (
      <PublicLayout>
        <ProductList />
      </PublicLayout>
    ),
  },
  {
    path: ROUTE_PATH.DESIGNER_PRODCUTS_LIST,
    element: (
      <PublicLayout>
        <DesignerProductsList />
      </PublicLayout>
    ),
  },
  {
    path: ROUTE_PATH.PAYMENT_SUCCESS,
    element: (
      <PublicLayout>
        <PaymentSuccessPage />
      </PublicLayout>
    ),
  },
  {
    path: ROUTE_PATH.PAYMENT_FAILURE,
    element: (
      <PublicLayout>
        <PaymentFailedPage />
      </PublicLayout>
    ),
  },
  {
    path: ROUTE_PATH.CLOSET,
    element: (
      <PublicLayout  >
        <Closet />
      </PublicLayout>
    ),
  },
  {
    path: ROUTE_PATH.KEEP_ITEMS_PAYMENT_SUCCESS,
    element: (
      <PublicLayout privateRoute={true} >
        <KeepItemsPaymentSuccess />
      </PublicLayout>
    ),
  },
  {
    path: ROUTE_PATH.ORDER_HISTORY,
    element: (
      <PublicLayout privateRoute={true} >
        <OrderHistory />
      </PublicLayout>
    ),
  },
  {
    path: ROUTE_PATH.ORDER_HISTORY_DETAILS,
    element: (
      <PublicLayout privateRoute={true} >
        <OrderHistoryDistails />
      </PublicLayout>
    ),
  },
  {
    path: ROUTE_PATH.USER_PROFILE,
    element: (
      <PublicLayout privateRoute={true} >
        <UserProfile />
      </PublicLayout>
    ),
  },
  {
    path: ROUTE_PATH.EDIT_PROFILE,
    element: (
      <PublicLayout privateRoute={true} >
        <EditProfile />
      </PublicLayout>
    ),
  },
  {
    path: ROUTE_PATH.SETTINGS,
    element: (
      <PublicLayout privateRoute={true} >
        <Settings />
      </PublicLayout>
    ),
  },
  {
    path: ROUTE_PATH.CUSTOMER_SUPPORT,
    element: (
      <PublicLayout >
        <CustomerSupport />
      </PublicLayout>
    ),
  },
  {
    path: ROUTE_PATH.FORGET_PASSWORD,
    element: (
      <PublicLayout>
        <ForgetPassword />
      </PublicLayout>
    ),
  },
  {
    path: ROUTE_PATH.FORGET_PASSWORD_CHECK_INBOX,
    element: (
      <PublicLayout>
        <CheckInbox />
      </PublicLayout>
    ),
  },
  {
    path: ROUTE_PATH.RESET_PASSWORD,
    element: (
      <PublicLayout>
        <ResetPassword />
      </PublicLayout>
    ),
  },
  {
    path: ROUTE_PATH.RESET_LINK_EXPIRED,
    element: (
      <PublicLayout>
        <LinkExpired />
      </PublicLayout>
    ),
  },
  {
    path: "*",
    element: (
      <PublicLayout>
        <Error />
      </PublicLayout>
    ),
  },
]);

export default routes;
